// extracted by mini-css-extract-plugin
export default {"EllipsisButton":"EllipsisButton_9zvrg","Button":"Button_4NjBk","items":"items_hg-WD","item":"item_D3YJ0","active":"active_KSKbw"};